module.exports = __webpack_public_path__ + "assets_1789888786567/img/pic_7.ffc234f7.png";